import { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { Spinner, Stack } from '@guestyci/arc';
import { utils } from 'utils';
import { deleteSecureAuthCookie } from '../../login/helpers';
import { handleLogout } from '../../logout/helper';
import { LoginPageShell } from '../layout';

const PERSISTED_KEYS = [
  'lang',
  /^smartviews-.*\.savereminder$/,
  'permanentStorage',
];

const redirectToLogin = (history) => {
  history.replace({
    pathname: '/login',
    search: window.location.search,
    state: { fromLogout: true },
  });
};

const LogoutPage = () => {
  const { oktaAuth } = useOktaAuth();
  const { search } = useLocation();
  const history = useHistory();

  utils.usePageView('logout');

  useEffect(() => {
    const queryParams = new URLSearchParams(search);
    const returnTo = queryParams.get('return_to');
    const isZendeskAuthorization = !!queryParams.get('zendeskSso');
    const persistedUserData = utils.localStorage.findItems(PERSISTED_KEYS);

    const logout = async () => {
      try {
        await deleteSecureAuthCookie();
        await handleLogout(oktaAuth);

        if (persistedUserData.length) {
          persistedUserData.forEach(item => {
            window.localStorage.setItem(item.key, item.value);
          });
        }

        if (isZendeskAuthorization && returnTo) {
          window.location.replace(returnTo);
        } else {
          redirectToLogin(history);
        }
      } catch (e) {
        console.error(e);
        redirectToLogin(history);
      }
    };

    logout();
  }, [oktaAuth, history, search]);

  return (
    <LoginPageShell>
      <Stack spacing={4} align="center" justify="center" className="gst-py-20">
        <Spinner size="xl" />
      </Stack>
    </LoginPageShell>
  );
};

export default LogoutPage;
